<template>
  <div>
    <Modal v-model="visible" width="90%" title="明细" :footer-hide="true" :mask-closable="false" class="my-modal top static">
      <div class="table-box setTable">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="reportName">
            <span class="report-name" @click="toDetail(row)">{{ row.reportName }}</span>
          </template>
        </Table>
        <Page
          :total="total"
          :current="pageNum"
          :page-size="pageSize"
          show-total
          @on-change="getList"
          :page-size-opts="[10, 20, 30, 50, 100]"
          style="text-align: center"
        />
      </div>
    </Modal>
  </div>
</template>
    
    <script>
import { common, pageTool } from '@/api/mixins';
import { config } from './detailModalRef.config.js';
export default {
  mixins: [common, pageTool, config],
  components: {},
  data() {
    return {
      columns: [],
      visible: false,
      loading: false,
      detail: {},
      settleId: '',
      searchParams: {},
      commissionTypeList: '',
      selectedIdsObj: {}
    };
  },
  mounted() {},
  methods: {
    open(data) {
      this.searchParams = {...data};
      this.getColumns();
      this.tableData = [];
      this.visible = true;
      this.getList();
    },
    getList() {
      this.$http({
        url: '/buz/ifaSettlementReport/queryItemList',
        data: this.searchParams
      }).then(res => {
        this.tableData = res.data || [];
      });
    }
  }
};
</script>
    <style lang="scss" scoped>
/deep/.ivu-modal-body {
  padding-top: 20px !important;
}
</style>
    